import {
  DIAGNOSTIC_CAPABILITY_KEYS,
  isEmergencyDepartmentLocation,
} from "../../constants/diagnosticCapabilities";
import { FACILITY_SUBTYPE } from "../../constants/facilityTypes";
import { hasFacilityDataAdminCapability } from "../../config/facilityDataAdmin";

/**
 * @param {string[]} a
 * @param {string[]} b
 * @returns {boolean}
 */
export function capabilitiesEqual(a, b) {
  const sa = [...(Array.isArray(a) ? a : [])].sort();
  const sb = [...(Array.isArray(b) ? b : [])].sort();
  return JSON.stringify(sa) === JSON.stringify(sb);
}

/**
 * ED inversion: full selection → empty array (implicit full); subset → de-attested list.
 * Urgent Care and Clinic: write exactly what is checked (empty = zero capabilities).
 *
 * @param {string[]} caps
 * @param {object | null | undefined} locationDoc
 * @returns {string[]}
 */
export function normalizeCapsForWrite(caps, locationDoc) {
  if (!isEmergencyDepartmentLocation(locationDoc)) {
    return caps;
  }
  if (capabilitiesEqual(caps, DIAGNOSTIC_CAPABILITY_KEYS)) {
    return [];
  }
  return caps;
}

/**
 * Whether the user may edit facilitySubtypes on their location.
 *
 * @param {string | null | undefined} userRole
 * @returns {boolean}
 */
export function canEditFacilityType(userRole) {
  return (
    userRole === "facility" ||
    userRole === "f2" ||
    hasFacilityDataAdminCapability(userRole)
  );
}

/**
 * facilitySubtypes array for urgent-care toggle.
 *
 * @param {boolean} acceptsWalkIns
 * @returns {string[]}
 */
export function urgentCareSubtypes(acceptsWalkIns) {
  return acceptsWalkIns
    ? [FACILITY_SUBTYPE.CLINIC, FACILITY_SUBTYPE.URGENT_CARE]
    : [FACILITY_SUBTYPE.CLINIC];
}
